import { useState } from "react";

import Image from "global/Image";

import { EyeButton, Input } from "./styled";

const PasswordInput = ({ error = false, ...rest }) => {
  const [type, setType] = useState("password");
  return (
    <Input
      type={type}
      className={error ? 'error' : ''}
      suffix={
        <EyeButton
          type="button"
          onClick={() => setType(type === 'text' ? 'password' : 'text')}
          data-cy="custom-input-password-eye-toggle"
        >
          <Image
            src={type === 'password' ? '/icon/eye.svg' : '/icon/eye-off.svg'}
            alt=""
          />
        </EyeButton>
      }
      {...rest}
    />
  );
};

export default PasswordInput;
